import axios from "axios";
import { useAuth } from "./store";

export const api = axios.create({
  baseURL: "/admin/v1",
  timeout: 15000,
});

api.interceptors.request.use((cfg) => {
  const token = useAuth.getState().token;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      useAuth.getState().logout();
    }
    return Promise.reject(err);
  }
);

export type DashboardMetric = {
  users: number;
  active_devices_7d: number;
  groups: number;
  posts_today: number;
  pending_reports: number;
  red_packets_today: number;
};

export type DashboardData = {
  metrics: DashboardMetric;
  posts_7d: { day: string; count: number }[];
  chain_dist: { chain: string; count: number }[];
};

export type AdminUser = {
  id: string;
  wallet_addr: string;
  username: string | null;
  avatar_url: string | null;
  status: number;
  created_at: string;
};

export type Report = {
  id: string;
  reporter_id: string | null;
  target_type: string;
  target_id: string;
  reason: string | null;
  detail: string | null;
  status: number;
  created_at: string;
  target_content?: string | null;
};

export type DApp = {
  id: string;
  name: string;
  url: string;
  icon_url: string | null;
  description: string | null;
  category: string | null;
  chains: string[] | null;
  status: number;
  risk_score: number;
  visit_count: number;
};

export type AuditLog = {
  id: number;
  actor_id: string | null;
  actor_role: string | null;
  action: string;
  target: string | null;
  payload: any;
  ip: string | null;
  created_at: string;
};

export type AdminGroup = {
  id: string;
  name: string;
  avatar_url: string | null;
  owner_id: string;
  owner_name: string | null;
  member_count: number;
  max_members: number;
  status: number;
  created_at: string;
};

export type AdminRedPacket = {
  id: string;
  contract_id: string;
  sender_id: string;
  sender_name: string | null;
  group_id: string | null;
  chain: string;
  token: string;
  total_amount: string;
  total_count: number;
  claimed_count: number;
  is_random: boolean;
  status: number;
  tx_hash: string | null;
  expires_at: string;
  created_at: string;
};

export type RedPacketReconcileRun = {
  id: string;
  chain: string;
  contract: string | null;
  from_block: number | null;
  to_block: number | null;
  scanned_events: number;
  claims_updated: number;
  refunds_updated: number;
  failed_txs: number;
  error: string | null;
  created_at: string;
};

export type Setting = {
  key: string;
  value: any;
  description: string | null;
  updated_at: string;
};

export type ModRule = {
  id: string;
  pattern: string;
  rule_type: number;
  target: string;
  action: string;
  enabled: boolean;
  note: string | null;
  created_at: string;
};
